import fetchCustom from '@helpers/fetchCustom';

export function getRecruitmentFlows() {
    return fetchCustom('/api/flows', { method: 'GET' });
}

export function getRecruitmentFlowStepsMeta() {
    return fetchCustom('/api/flows/steps?sorted=true', { method: 'GET' });
}

export function deleteRecruitmentFlow(flowId) {
    return fetchCustom(`/api/flows/${flowId}`, { method: 'DELETE' });
}

export function putRecruitmentFlowDefault(flowId) {
    return fetchCustom(`/api/flows/${flowId}/default`, { method: 'PUT' });
}

export function getFlowById(flowId) {
    return fetchCustom(`/api/flows/${flowId}`, { method: 'GET' });
}

export function postRecruitmentFlow(payload) {
    return fetchCustom('/api/flows', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        },
        body: JSON.stringify(payload),
    });
}
